export default (list, key, match) => {
    let itemIndex = null;
    let foundItem = null;
    for (let i = 0; i < list.length; i++) {
      if (list[i][key] === match) {
        itemIndex = i;
        foundItem = { ...list[i] };
        break;
      }
    }
    return { itemIndex, foundItem }
  }